import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    retailersGet,
    retailersGetById,
    retailerCreate,
    retailerUpdate,
    retailerDelete
} from "api/menu/master-files/retailers/requests";

export const FETCH_RETAILERS_SUCCESS = "FETCH_RETAILERS_SUCCESS";
export const FETCH_RETAILER_BY_ID_SUCCESS = "FETCH_RETAILER_BY_ID_SUCCESS";

export const RETAILERS_REQUEST_LOADING = "RETAILERS_REQUEST_LOADING";
export const RETAILERS_REQUEST_ERRORS = "RETAILERS_REQUEST_ERRORS";

export const setLoading = () => ({
    type: RETAILERS_REQUEST_LOADING
});

export const fetchRetailers = (includeInactive = false) => dispatch => {
    dispatch(setLoading());
    retailersGet(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_RETAILERS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, RETAILERS_REQUEST_ERRORS));
        });
};

export const fetchRetailerById = (id) => dispatch => {
    retailersGetById(id)
        .then(response => {
            dispatch({
                type: FETCH_RETAILER_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, RETAILERS_REQUEST_ERRORS));
        });
};

export const insertRetailer = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    retailerCreate(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Retailer "${data.name}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateRetailer = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    retailerUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Retailer "${data.name}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteRetailer = (id, name, callback = false) => dispatch => {
    dispatch(setLoading());
    retailerDelete(id)
        .then(() => {
            toast(`Retailer "${name}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, RETAILERS_REQUEST_ERRORS));
        });
};

export const clearRetailers = () => dispatch => {
    dispatch({
        type: FETCH_RETAILERS_SUCCESS,
        payload: []
    });
};

export const clearSingleRetailer = () => dispatch => {
    dispatch({
        type: FETCH_RETAILER_BY_ID_SUCCESS,
        payload: []
    });
};
